/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Divider, Grid, Typography, useMediaQuery } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { BsListUl } from "react-icons/bs";
import { AiOutlineWechat } from "react-icons/ai";
import { MdEmail, MdOutlineMarkEmailRead } from "react-icons/md";
import ListProblem from './ComponentList/ListProblem';
import ListProductAndService from './ComponentList/ListProductAndService';
import ListSuggestion from './ComponentList/ListSuggestion';
import ListClose from './ComponentList/ListClose';
import "./StyleCard/CardBox.css"
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
// import AOS from "aos";
import Collapse from '@mui/material/Collapse';
import { i18n } from 'i18n';
import { AuthToken, currentLanguage, useUnauthorize } from 'service/CommonFunction/AxiosConfig';

const i18nField = 'entities.MyVOCList.fields';
const MyListVOC = () => {

    const navigate = useNavigate();

    const Layout1100 = useMediaQuery('(min-width:1100px)');
    const Layout1000 = useMediaQuery('(min-width:1000px)');

    const [ArrCard, setArrCard] = useState([] as any)
    const [IsHasPermission, setIsHasPermission] = useState(false)
    const [CardAction, setCardAction] = useState(1)
    const [Option, setOption] = useState({
        lstVOCType: [],
        lstVOCFormType: [],
        lstProductServiceType: [],
        lstStatus: [],
    })

    useEffect(() => {
        let auth = AuthToken.get();
        if (auth != null && auth != "") {
            setIsHasPermission(true)
            GetAllOption();
        } else {
            navigate("/Home")
            useUnauthorize.set(true)
            useUnauthorize.set(false)
        }
    }, [])

    useEffect(() => {
        let auth = AuthToken.get();
        if (auth != null && auth != "") {
            GetDashboard();
        } else {
            navigate("/Home")
            useUnauthorize.set(true)
            useUnauthorize.set(false)
        }
    }, [CardAction])

    const GetDashboard = async () => {
        let nYear = moment().year();
        await AxiosGet(`MyVOC/GetMyVOCDashboard`, { "nYear": nYear, "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                setArrCard(res.result?.data)
            })
        });
    }

    const GetAllOption = async () => {

        //
        let oOptionVOC = {
            lstVOCType: [],
            lstVOCFormType: [],
            lstProductServiceType: [],
            lstStatus: [],
        };

        //#region  New
        await AxiosGet(`BAService/GetBAType`, { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCType: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetVOCFormType`, { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCFormType: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetStatusMyVOC`, { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstStatus: res.result?.data || [] }
            })
        });

        await AxiosGet(`VOC/GetOptionPrdService`, { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstProductServiceType: res.result?.data || [] }
            })
        });

        //#endregion

        await onSetOption(oOptionVOC);
    }

    const onSetOption = async (paramOption) => {
        setOption(paramOption)
    }


    const JsxBoxCard = (dataItem, nCard) => {

        let JsxElement = null;

        switch (nCard) {
            case 1:
                JsxElement =
                    <div className="containerCard" onClick={() => { onHandleChangeBox(nCard) }}>
                        <div className="card1" style={{ background: CardAction == 1 ? "#ffdbe6" : "#f1f1f1" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><MdEmail style={{ color: '#d9001b' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 2:
                JsxElement =
                    <div className="containerCard" onClick={() => { onHandleChangeBox(nCard) }}>
                        <div className="card2" style={{ background: CardAction == 2 ? "#cbe2ff" : "#f1f1f1" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><MdEmail style={{ color: '#016efe' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 3:
                JsxElement =
                    <>
                        <div className="containerCard" onClick={() => { onHandleChangeBox(nCard) }}>
                            <div className="card3" style={{ background: CardAction == 3 ? "#ffe5d8" : "#f1f1f1" }}>
                                <div className="borderBoxEmpty"></div>
                                <div className="IconBoxVoc"><MdEmail style={{ color: '#ff7c35' }} /></div>
                                <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                                <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                            </div>
                        </div>
                    </>
                break;
            case 4:
                JsxElement =
                    <div className="containerCard" onClick={() => { onHandleChangeBox(nCard) }}>
                        <div className="card4" style={{ background: CardAction == 4 ? "linear-gradient(90deg, rgba(0,236,145,1) 0%, rgba(0,163,244,1) 100%)" : "#f1f1f1" }}>
                            <div className="borderBoxEmpty" style={{ background: 'linear-gradient(90deg, rgba(0,236,145,1) 0%, rgba(0,163,244,1) 100%)' }}></div>
                            <div className="IconBoxVoc"><MdOutlineMarkEmailRead style={{ color: '#ffffff' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 5:
                JsxElement =
                    <div className="containerCard" onClick={() => { navigate("/Front/MyVOC/LiveChatVOC") }}>
                        <div className="card5" style={{ background: CardAction == 5 ? "#cdf4e8" : "#f1f1f1" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><AiOutlineWechat style={{ color: '#11c990' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            default:
                break;
        }

        return JsxElement;
    }

    const onHandleChangeBox = (nCard) => {
        setCardAction(nCard)
    }

    return (
        <>
            {
                IsHasPermission &&
                <div style={{ padding: !Layout1000 ? '2em 2em 0 2em' : '6em 2em 0 2em' }}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                        <Grid item xs={12}>
                            <InnerHeadRoutes
                                iconMUI={<BsListUl style={{ fontSize: '1.5em' }} />}
                                labal_Head={i18n(`${i18nField}.sPetition`)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2} direction="row" justifyContent={Layout1100 ? "space-around" : "start"} alignItems="center" >
                                {ArrCard != null && ArrCard.length === 0 ? null :
                                    ArrCard.map((dataItem, index) => {
                                        return (
                                            <Grid key={`f-card_${index}`} item xs={6}  md={"auto"}>
                                                {JsxBoxCard(dataItem, dataItem.nID)}
                                            </Grid>
                                        )
                                    })}
                            </Grid>
                        </Grid>
                        {CardAction === 1 ?
                            <Grid item xs={12}>
                                <ListProblem GetDashboard={GetDashboard} CardAction={CardAction} Option={Option} />
                            </Grid>
                            : null
                        }
                        {CardAction === 2 ?

                            <Grid item xs={12}>
                                <ListProductAndService GetDashboard={GetDashboard} CardAction={CardAction} Option={Option} />
                            </Grid>
                            : null
                        }
                        {CardAction === 3 ?
                            <Grid item xs={12}>
                                <ListSuggestion GetDashboard={GetDashboard} CardAction={CardAction} Option={Option} />
                            </Grid>
                            : null
                        }
                        {CardAction === 4 ?
                            <Grid item xs={12}>
                                <ListClose GetDashboard={GetDashboard} CardAction={CardAction} Option={Option} />
                            </Grid>
                            : null
                        }
                    </Grid>

                </div>
            }
        </>

    )
}

export default MyListVOC